import React, {useState} from "react";
import "./yearbookSearchFacet.scss";
import {Collapse, FormCheck} from "react-bootstrap";
import i18next from "../../../../i18n";
import FormCheckInput from "react-bootstrap/FormCheckInput";
import FormCheckLabel from "react-bootstrap/FormCheckLabel";

function _get_facet_name(facet_key) {
    const _facet_lookup = {
        'typename': i18next.t('publications_typename', 'Type'),
        'recurrence_volume': i18next.t('publications_facets.volume', 'Volume'),
        'recurrence_year': i18next.t('publications_facets.year', 'Year'),
    }
    return _facet_lookup[facet_key]
}

function _get_facet_value(facet_value) {
    const _val_lookup = (val) => {
        const _lookup = {
            'occasional_papers': i18next.t('publications.unoda_occasional_papers', 'UNODA Occasional Papers'),
            'disarmament_study_series': i18next.t('publications.disarmament_study_series', 'Disarmament Study Series'),
            'civil_society': i18next.t('publications.civil_society_disarmament', 'Civil Society and Disarmament'),
            'basic_guide': i18next.t('publications.disarmament_basic_guide', 'Disarmament: A Basic Guide'),
            'disarmament_res_dec': i18next.t('publications.disarmament_resolutions_decisions', 'Disarmament Resolutions and Decisions of the United Nations General Assembly'),
            'disarmament_crit_issues': i18next.t('publications.critical_disarmament_issues', 'Critical Disarmament Issues'),
            'yearbook': i18next.t('publications.disarmament_yearbook', 'Disarmament Yearbook'),
            'prog_fin_vol_contribs': i18next.t('publications.progs_financed_voluntary_contributions', 'Programmes Financed from Voluntary Contributions'),
            'other_pubs': i18next.t('publications.other_publications', 'Other Publications'),
        }
        return Object.keys(_lookup).includes(val) ? _lookup[val] : val
    }

    return _val_lookup(facet_value)
}

const YearbookSearchFacet = ({ facet, onFacetChange }) => {
    const {facetKey, facetList} = facet;
    const [open, setOpen] = useState(false);

    const _toggleFacet = (facet_key, facet_entry) => {
        const selected = !facet_entry.selected;
        const facetChangeEvent = {
            facet_key,
            facet_entry: {...facet_entry, selected}
        }
        onFacetChange(facetChangeEvent)
    }

    const FACET_LIMIT = 5;

    return (
        <div className="faceted-filter pb-3">
            <div className="pb-4">
                <h4 className="mb-0">{_get_facet_name(facetKey)}</h4>
            </div>
            {facetList.slice(0,FACET_LIMIT).map((facet_entry, index)=>{
                const {facet, count, selected} = facet_entry;
                return (
                    <>
                        <FormCheck
                            id={facet + '-' + index}
                            className={'d-flex flex-row'}
                            type={"checkbox"}>
                            <FormCheckInput
                                type={"checkbox"}
                                checked={selected}
                                onChange={()=>_toggleFacet(facetKey, facet_entry)} />
                            <FormCheckLabel className={'d-flex flex-row justify-content-between w-100'}>
                                <div>{_get_facet_value(facet)}</div>
                                <div>({count})</div>
                            </FormCheckLabel>
                        </FormCheck>
                    </>
            )
            })}
            { facetList.length > FACET_LIMIT &&
            <Collapse in={open}>
                <div id={"collapse-"+facetKey} className="facets-list my-0" >
                    {facetList.slice(FACET_LIMIT,facetList.length).map((facet_entry, index)=>{
                        const {facet, count, selected} = facet_entry;
                        return (
                            <>
                                <FormCheck
                                    id={facet + '-' + index}
                                    className={'d-flex flex-row'}
                                    type={"checkbox"}>
                                    <FormCheckInput
                                        type={"checkbox"}
                                        checked={selected}
                                        onChange={()=>_toggleFacet(facetKey, facet_entry)} />
                                    <FormCheckLabel className={'d-flex flex-row justify-content-between w-100'}>
                                        <div className={'fw-medium'}>{_get_facet_value(facet)}</div>
                                        <div>({count})</div>
                                    </FormCheckLabel>
                                </FormCheck>
                            </>
                        )
                    })}
                </div>
            </Collapse>
            }
            { facetList.length > FACET_LIMIT &&
                <a className="text-primary btn pt-0 pb-3" role="button" aria-expanded={open} aria-controls={"collapse-" + facetKey} onClick={() => setOpen(!open)}>
                    {open ? i18next.t('publications.show_less', "show less") : i18next.t('publications.show_more', "show more")}
                </a>
            }

        </div>

    )
}

export default YearbookSearchFacet;
